import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["earliestKind", "earliestDays", "earliestDaysField", "latestKind", "latestDays", "latestDaysField", "summary"]
  static values = { templates: Object }

  connect() {
    this.dateFormat = new Intl.DateTimeFormat(document.documentElement.lang, { dateStyle: "long" })
    this.refresh()
  }

  refresh() {
    this.toggleDays(this.earliestKindTarget, this.earliestDaysTarget, this.earliestDaysFieldTarget)
    this.toggleDays(this.latestKindTarget, this.latestDaysTarget, this.latestDaysFieldTarget)
    this.summaryTarget.textContent = this.summary(
      this.offset(this.earliestKindTarget, this.earliestDaysTarget),
      this.offset(this.latestKindTarget, this.latestDaysTarget)
    )
  }

  // Hidden and disabled, as disclosure does: a disabled input is not submitted.
  toggleDays(kindSelect, daysInput, daysField) {
    const needsDays = this.needsDays(kindSelect.value)
    daysField.hidden = !needsDays
    daysInput.disabled = !needsDays
  }

  needsDays(kind) {
    return kind === "before" || kind === "after"
  }

  offset(kindSelect, daysInput) {
    const kind = kindSelect.value
    if (kind === "today") return 0
    if (!this.needsDays(kind)) return null

    const days = parseInt(daysInput.value, 10) || 0
    return kind === "before" ? -days : days
  }

  summary(earliest, latest) {
    const templates = this.templatesValue
    if (earliest === null && latest === null) return templates.any
    if (latest === null) return templates.from.replace("%{earliest}", this.format(earliest))
    if (earliest === null) return templates.until.replace("%{latest}", this.format(latest))
    if (earliest > latest) return templates.impossible

    return templates.range.replace("%{earliest}", this.format(earliest)).replace("%{latest}", this.format(latest))
  }

  format(offset) {
    const date = new Date()
    date.setDate(date.getDate() + offset)
    return this.dateFormat.format(date)
  }
}
